
import {useAppDispatch} from "../../app/store/hooks.ts";
import {useCallback, useMemo} from "react";
import {updateBalance} from "../../app/store/slices/userSlice.ts";
import {UserApi} from "../api/userApi.ts";

export const useUserInfoUpdate = () => {
    const dispatch = useAppDispatch();
    const userApi = useMemo(() => new UserApi(), []);

    const updateUserInfo = useCallback(async () => {
        try {
            const { balance } = await userApi.getUserBalance();
            dispatch(updateBalance(balance));
        } catch (error) {
            console.error('Balance update error:', error);
        }
    }, [dispatch, userApi]);

    return updateUserInfo; // ← верни функцию!
}

